import { render, staticRenderFns } from "./Lol.vue?vue&type=template&id=fc0f5e16&lang=pug&"
import script from "./Lol.vue?vue&type=script&lang=js&"
export * from "./Lol.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/amazon-lol/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports